<template>
    <main class="flex flex-col h-screen">
        <HomeHeader></HomeHeader>
        <div class="px-6 flex-1 py-12">
            <section class="w-full max-w-5xl mx-auto">
                <slot></slot>
            </section>
        </div>
        <Footer></Footer>
    </main>
    <ModalsContainer />
</template>


<script setup>
import Button from "~/components/ui/Button.vue";
import SearchInput from "~/components/ui/SearchInput.vue";
const route = useRoute()
import Footer from "~/components/public/Footer.vue";
import HomeHeader from "~/components/public/HomeHeader.vue";
import { ModalsContainer } from 'vue-final-modal';

const { theme } = useTheme();

useHead({
    bodyAttrs: {
        class: 'overscroll-y-none'
    },
    style: [{
        innerHTML: `
            :root {
                --theme-link-color: ${theme.value.linkText};
                --theme-link-hover-color: ${theme.value.linkHover};
            }
            a {
                color: var(--theme-link-color);
                transition: color 0.15s ease;
            }
            a:hover {
                color: var(--theme-link-hover-color);
            }
        `
    }]
});
</script>
